export default "__VITE_PUBLIC_ASSET__f7c7b7aa__"